import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { UserProfileService } from '../services';
import { sleep } from '../utils';
import { HAYGENT_QUERY_KEY } from './haygent';

export const useImpersonatedUser = () => {
  const queryKey = ['impersonatedUser'];

  const queryFn = () => Promise.resolve<string | null>(null);

  return useQuery({
    queryKey,
    queryFn,
  });
};

export const setImpersonatedUser = async (user: string | null) => {
  queryClient.setQueryData(['impersonatedUser'], user);
  await queryClient.cancelQueries({ queryKey: HAYGENT_QUERY_KEY });
  queryClient.removeQueries({ queryKey: HAYGENT_QUERY_KEY });
  queryClient.invalidateQueries(['currentUser']);
  await queryClient.ensureQueryData({ queryKey: ['currentUser'], queryFn: UserProfileService.getMyProfile });
  // invalidate all queries in all places
  // make sure user is set before invalidating queries and add a delay to make sure the enabled property can be set correctly

  await sleep(2000);
  queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0];
      // Don't invalidate impersonation state, current user, or fleet data
      return key !== 'impersonatedUser' && key !== 'currentUser' && key !== 'fleetOverride' && key !== 'fleet' && key !== 'previewEventID';
    },
  });
};
